import { fetchFamilies } from '@gn-audio/core/api/product-catalogue/fetch-families';
import { fetchGroups } from '@gn-audio/core/api/product-catalogue/fetch-groups';
import { fetchProducts } from '@gn-audio/core/api/product-catalogue/fetch-products';
export var fetchProductsByType = function (productIds, productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroups(productIds);
            break;
        case "p" /* Product */:
            promise = fetchProducts(productIds);
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamilies(productIds);
            break;
    }
    return promise;
};
